var map = {
	"app/auth/login/login.module": [
		"../../../../../src/app/auth/login/login.module.ts",
		"login.module"
	],
	"app/auth/register/register.module": [
		"../../../../../src/app/auth/register/register.module.ts",
		"register.module"
	],
	"app/main/about-us/about-us.module": [
		"../../../../../src/app/main/about-us/about-us.module.ts",
		"about-us.module"
	],
	"app/main/agent-requests/agent-requests.module": [
		"../../../../../src/app/main/agent-requests/agent-requests.module.ts",
		"agent-requests.module"
	],
	"app/main/bank-requests/bank-requests.module": [
		"../../../../../src/app/main/bank-requests/bank-requests.module.ts",
		"bank-requests.module"
	],
	"app/main/benifit-management/benifit-management.module": [
		"../../../../../src/app/main/benifit-management/benifit-management.module.ts",
		"common",
		"benifit-management.module"
	],
	"app/main/biller/biller.module": [
		"../../../../../src/app/main/biller/biller.module.ts",
		"common",
		"biller.module"
	],
	"app/main/brms/brms.module": [
		"../../../../../src/app/main/brms/brms.module.ts",
		"brms.module"
	],
	"app/main/campaign-management/campaign-management.module": [
		"../../../../../src/app/main/campaign-management/campaign-management.module.ts",
		"common",
		"campaign-management.module"
	],
	"app/main/cash-in-manager/cash-in-manager.module": [
		"../../../../../src/app/main/cash-in-manager/cash-in-manager.module.ts",
		"cash-in-manager.module"
	],
	"app/main/dashboard/dashboard.module": [
		"../../../../../src/app/main/dashboard/dashboard.module.ts",
		"common",
		"dashboard.module"
	],
	"app/main/fund-transfer/fund-transfer.module": [
		"../../../../../src/app/main/fund-transfer/fund-transfer.module.ts",
		"common",
		"fund-transfer.module"
	],
	"app/main/group-limit-management/group-limit-management.module": [
		"../../../../../src/app/main/group-limit-management/group-limit-management.module.ts",
		"group-limit-management.module"
	],
	"app/main/hierarchy-management/heirarchy.module": [
		"../../../../../src/app/main/hierarchy-management/heirarchy.module.ts",
		"heirarchy.module"
	],
	"app/main/kyc/kyc.module": [
		"../../../../../src/app/main/kyc/kyc.module.ts",
		"common",
		"kyc.module"
	],
	"app/main/limits-capping/limits.module": [
		"../../../../../src/app/main/limits-capping/limits.module.ts",
		"limits.module"
	],
	"app/main/login-management/login.module": [
		"../../../../../src/app/main/login-management/login.module.ts",
		"common",
		"login.module.0"
	],
	"app/main/loyalty-management/loyalty-management.module": [
		"../../../../../src/app/main/loyalty-management/loyalty-management.module.ts",
		"common",
		"loyalty-management.module"
	],
	"app/main/manage-products/manage-module": [
		"../../../../../src/app/main/manage-products/manage-module.ts",
		"manage-module"
	],
	"app/main/notification/notification.module": [
		"../../../../../src/app/main/notification/notification.module.ts",
		"common",
		"notification.module"
	],
	"app/main/operations/operations.module": [
		"../../../../../src/app/main/operations/operations.module.ts",
		"operations.module"
	],
	"app/main/prodigi-credit/prodigi-credit.module": [
		"../../../../../src/app/main/prodigi-credit/prodigi-credit.module.ts",
		"common",
		"prodigi-credit.module"
	],
	"app/main/promo-code-management/promocode.module": [
		"../../../../../src/app/main/promo-code-management/promocode.module.ts",
		"common",
		"promocode.module"
	],
	"app/main/promotional-campaigns/promotional-campaigns.module": [
		"../../../../../src/app/main/promotional-campaigns/promotional-campaigns.module.ts",
		"common",
		"promotional-campaigns.module"
	],
	"app/main/refferral-management/refferral-management.module": [
		"../../../../../src/app/main/refferral-management/refferral-management.module.ts",
		"refferral-management.module"
	],
	"app/main/reports/reports.module": [
		"../../../../../src/app/main/reports/reports.module.ts",
		"common",
		"reports.module"
	],
	"app/main/rule-set-management/ruleSet.module": [
		"../../../../../src/app/main/rule-set-management/ruleSet.module.ts",
		"common",
		"ruleSet.module"
	],
	"app/main/service-group-management/serviceGroup.module": [
		"../../../../../src/app/main/service-group-management/serviceGroup.module.ts",
		"common",
		"serviceGroup.module"
	],
	"app/main/service-management/service-management.module": [
		"../../../../../src/app/main/service-management/service-management.module.ts",
		"common",
		"service-management.module"
	],
	"app/main/settlement/settlement.module": [
		"../../../../../src/app/main/settlement/settlement.module.ts",
		"settlement.module"
	],
	"app/main/smsc-module/reports/reports.module": [
		"../../../../../src/app/main/smsc-module/reports/reports.module.ts",
		"common"
	],
	"app/main/smsc-module/smsc.module": [
		"../../../../../src/app/main/smsc-module/smsc.module.ts",
		"common",
		"smsc.module"
	],
	"app/main/transaction/transaction.module": [
		"../../../../../src/app/main/transaction/transaction.module.ts",
		"common",
		"transaction.module"
	],
	"app/main/user-group-management/userGroup.module": [
		"../../../../../src/app/main/user-group-management/userGroup.module.ts",
		"common",
		"userGroup.module"
	],
	"app/main/ussd/ussd.module": [
		"../../../../../src/app/main/ussd/ussd.module.ts",
		"ussd.module"
	],
	"app/main/wallet-management/wallet-management.module": [
		"../../../../../src/app/main/wallet-management/wallet-management.module.ts",
		"common",
		"wallet-management.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_gendir lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// /Users/ldt/Desktop/afropay_admin/afropay-admin-frontend/src/$$_gendir lazy
// module id = ../../../../../src/$$_gendir lazy recursive
// module chunks = main